// extracted by mini-css-extract-plugin
export default {"subBusinessId":"user-access_subBusinessId__kfSwb","imageSize":"user-access_imageSize__wdRUL","viewPhoto":"user-access_viewPhoto__o-nfe"};